import type { Carer, Resident } from '@lmc/ts-common'
import dayjs from 'dayjs'

export const getCarerName = (id: string, carers: Carer[]) => {
  const carer = carers?.find((carer) => carer.id === id)
  return carer ? `${carer?.name?.first} ${carer?.name?.last}` : undefined
}

export const getTitle = (
  editedBy: string,
  editedOn: Date,
  translation: string,
  carers: Carer[]
) => {
  const name = getCarerName(editedBy, carers)
  return name
    ? `${editedOn ? translation : ''}${dayjs(editedOn).format(
        'DD-MM-YYYY'
      )} · ${name}`
    : ''
}

export const getHistoryTitle = (translation: string, resident: Resident) =>
  `${resident.name.first} ${resident.name.last}${translation}`
